import React, {useMemo} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import styles from './styles/document.module.css';

export default function Document({ content, references }) {
    const containerRefHeight = useMemo(() => {
        const count = references.length;

        if (count === 0) return 0;

        const itemHeight = 27 + 8; // referecnce height 27px + gap 8px
        
        const minHeight = itemHeight; // 최소 높이 (1개일 때)
        
        const maxHeight = itemHeight * 4 - 8; // 최대 높이 (4개일 때), 마지막 항목의 gap 제외
        
        const calculatedHeight = Math.min(count * itemHeight - (count > 0 ? 8 : 0), maxHeight); // 실제 높이 계산 (1 ~4 개는 항목 수에 비례, 5개 이상은 최대 높이)
        
        return calculatedHeight;
    }, [references.length]);
    
    const contentHeight = useMemo(() => {
        const remainingHeight = 563 - (containerRefHeight + 28 + 14); // 전체 높이(563px) - (containerRef 높이 + 패딩 28px + containerRef와 content 사이 마진 14px)
        return remainingHeight;
    }, [containerRefHeight]);
    
    const containerRefStyle = {
        height: containerRefHeight ? `${containerRefHeight}px` : '0px',
        overflowY: references.length > 4 ? 'scroll' : 'hidden'
    };
    
    const contentStyle = {
        height: `${contentHeight}px`,
        minHeight: 'unset'
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.content} style={contentStyle}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {content}
                </ReactMarkdown>
            </div>
            <div className={styles.containerRef} style={containerRefStyle}>
                {references.map((reference, index) => (
                    <div className={styles.reference} key={index}>
                        <p>출처 {index + 1} | {reference.sheetName && reference.sheetName !== 'null' ? `${reference.fileName} > ${reference.sheetName}` : `${reference.fileName}`}</p>
                        <div>score : {reference.score}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
